import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TRANSLATION_KEYS } from '@core/internationalization/translations_keys';
import { APP_SLUGS, MAIN_SLUGS } from '@routes/routes.types';
import { LucideAngularModule, Maximize2, Settings, Sparkles, X } from 'lucide-angular';
import { AgentChatService } from '../../services/agent-chat.service';
import { AgentChatPanelService } from '../../services/agent-chat-panel.service';
import { AgentChatSettingsService } from '../../services/agent-chat-settings.service';
import { AgentChatThreadComponent } from '../agent-chat-thread/agent-chat-thread.component';

/**
 * Non-modal right slide-in panel hosting the chat surface. Stays out of the way
 * (no backdrop) so the user keeps working while chatting. Mounted once in the
 * main shell; visibility driven by AgentChatPanelService.
 */
@Component({
    selector: 'app-agent-chat-panel',
    imports: [TranslateModule, LucideAngularModule, AgentChatThreadComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './agent-chat-panel.component.html',
    styles: [':host { display: contents; }'],
})
export class AgentChatPanelComponent {
    protected readonly panelS = inject(AgentChatPanelService);
    protected readonly settingsS = inject(AgentChatSettingsService);
    private readonly chatS = inject(AgentChatService);
    private readonly router = inject(Router);

    protected readonly T = TRANSLATION_KEYS.agentChat;
    protected readonly SparklesIcon = Sparkles;
    protected readonly CloseIcon = X;
    protected readonly ExpandIcon = Maximize2;
    protected readonly SettingsIcon = Settings;

    constructor() {
        // Honour the configured default agent as soon as the panel is shown.
        effect(() => {
            if (this.panelS.isOpen()) this.chatS.applyDefaultAgent();
        });
    }

    protected openFullView(): void {
        this.panelS.close();
        this.router.navigate([APP_SLUGS.MAIN, MAIN_SLUGS.agentChat]);
    }
}
